import {
    SelectionPanelGroup,
    SelectionPanelGroupComponentSpacing,
    SelectionPanelGroupLayoutStyle,
    SelectionPanelGroupStyleMode,
    SelectionPanelGroupTheme,
    SelectionPanelGroupSelectionType,
} from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';
import { OwnerAndCompanyBackgroundId, ownerAndCompanyBackgroundOptions } from '../constants/applicationKeyItemsForm';

const items = ownerAndCompanyBackgroundOptions.map((option) => ({ id: option.id, children: option.label }));

export const OwnerAndCompanyBackgroundField = () => {
    const value = useWizardDemoStore((state) => state.applicationKeyItems.ownerAndCompanyBackground);
    const updateApplicationKeyItems = useWizardDemoStore((state) => state.updateApplicationKeyItems);

    return (
        <SelectionPanelGroup
            id='applicationOwnerAndCompanyBackground'
            items={items}
            theme={SelectionPanelGroupTheme.Blue}
            selectedPanels={value}
            set_selectedPanels={(ids) =>
                updateApplicationKeyItems({ ownerAndCompanyBackground: ids as OwnerAndCompanyBackgroundId[] })
            }
            selectionType={SelectionPanelGroupSelectionType.Multiple}
            styleMode={SelectionPanelGroupStyleMode.Condensed}
            label='Background — Company & 20%+ Owners have:'
            layoutStyle={SelectionPanelGroupLayoutStyle.Vertical}
            componentSpacing={SelectionPanelGroupComponentSpacing.LargeSpacing}
        />
    );
};
